import { createClient } from '@sanity/client'

const projectId = 'urerbr0z'
const dataset = 'production'

// Read-only client (no token needed for public dataset).
// There is deliberately no write client here: a Sanity write token in the browser
// would be inlined into the CRA bundle and readable by anyone. All writes (blog
// posts and image uploads) go through the admin backend, which holds the token
// server side. See services/sanityBlog.service.ts and upload.service.ts.
export const sanityReadClient = createClient({
  projectId,
  dataset,
  apiVersion: '2024-01-01',
  useCdn: false,
})
